import React from "react";

interface AllChipProps {
	size?: "small" | "medium" | "large";
}

export const AllChip: React.FC<AllChipProps> = ({ size = "medium" }) => {
	const getSizeStyles = () => {
		switch (size) {
			case "small":
				return {
					padding: "2px 6px",
					fontSize: "0.75rem",
					minWidth: "20px",
					height: "20px",
				};
			case "large":
				return {
					padding: "4px 12px",
					fontSize: "0.875rem",
					minWidth: "32px",
					height: "32px",
				};
			default: // medium
				return {
					padding: "4px 8px",
					fontSize: "0.8125rem",
					minWidth: "24px",
					height: "24px",
				};
		}
	};

	const baseStyles: React.CSSProperties = {
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: "4px",
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		lineHeight: "1.5",
		cursor: "default",
		fontWeight: 800,
		color: "rgb(255, 255, 255)",
		backgroundColor: "#6c757d",
		border: "1px solid #6c757d",
		...getSizeStyles(),
	};

	return <div style={baseStyles}>All</div>;
};
